import React, { PureComponent } from 'react';

import ReactTable from 'react-table';

import styled from 'styled-components';
import FilterDropdown from 'comps/filter/filter-dropdown';
import FilterDate from 'comps/filter/filter-date';
import { epochToDate, epochToTime } from 'utils';
import { Link } from 'react-router-dom';

import { FORM_ACTIONS } from 'constants/form';
import { classStatus, classType, reviewStatus } from 'constants/reviews';

const TableWrapper = styled.div`
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

class TeacherClassroom extends PureComponent {
  onFilteredChange = filters => {
    this.props.onFilter(filters);
  };

  render() {
    const { tableData, defaultPageSize, style, onPageChange } = this.props;

    let pageSize = defaultPageSize ? defaultPageSize : 20;

    const tableColumns = [
      {
        columns: [
          {
            Header: 'Date',
            accessor: 'date',
            width: 180,
            filterable: true,
            Cell: ({ value }) => (value ? epochToDate(value, 'DD/MM/YYYY, LT') : ''),
            Filter: ({ filter, onChange }) => {
              return <FilterDate filter={filter} onChange={onChange} />;
            },
          },
          {
            Header: 'Scheduled Start Time',
            accessor: 'scheduled_start_time',
            width: 150,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Scheduled End Time',
            accessor: 'scheduled_end_time',
            width: 150,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Enter Time',
            accessor: 'enter_time',
            width: 100,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Exit Time',
            accessor: 'exit_time',
            width: 100,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Class Status',
            accessor: 'status',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={classStatus}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'Class Logs',
            accessor: '',
            width: 200,
            Cell: row => {
              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/users/teacher-classroom/${row.original.id}`,
                    state: {
                      formType: FORM_ACTIONS.VIEW,
                      student: row.original,
                    },
                  }}
                >
                  Class Logs
                </LinkNav>
              );
            },
          },
          {
            Header: 'Class Type',
            accessor: 'class_type',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={classType}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          /*{
            Header: 'Call Duration (mins)',
            accessor: 'call_logs_duration',
            width: 160,
            Cell: ({ value }) => (value ? parseInt(value / 60) : ''),
          },
          This column will be enabled later */
          {
            Header: 'Review Status',
            accessor: 'review_status',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={reviewStatus}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
        ],
      },
    ];

    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={tableData}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={pageSize}
            style={style}
            columns={tableColumns}
            onFilteredChange={this.onFilteredChange}
            defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
            onPageChange={onPageChange}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}

export default TeacherClassroom;
